export default class HistoricoPedidoImportacao {
  id: number;
  dataEvento: Date;
  objeto: string;
  quem: string;
  d_E_L_E_T_E: boolean;
  criadoEm: Date;
  excluidoEm: Date;

  constructor(
    id: number,
    dataEvento: Date,
    objeto: string,
    quem: string,
    d_E_L_E_T_E: boolean,
    criadoEm?: Date,
    excluidoEm?: Date
  ) {
    this.id = id;
    this.dataEvento = dataEvento;
    this.objeto = objeto;
    this.quem = quem;
    this.d_E_L_E_T_E = d_E_L_E_T_E;
    this.criadoEm = criadoEm ?? new Date();
    this.excluidoEm = excluidoEm ?? new Date();
  }

  static toJson(historicoPedidoImportacao: HistoricoPedidoImportacao): string {
    return JSON.stringify(historicoPedidoImportacao);
  }

  static fromJson(json: object[]): HistoricoPedidoImportacao[] {
    let historicoPedidoImportacaoArr: HistoricoPedidoImportacao[] = [];
    json.forEach((item: any) => {
      historicoPedidoImportacaoArr.push(
        new HistoricoPedidoImportacao(
          item["id"],
          item["dataEvento"],
          item["objeto"],
          item["quem"],
          item["d_E_L_E_T_E"],
          new Date(item["criadoEm"]),
          new Date(item["excluidoEm"])
        )
      );
    });
    return historicoPedidoImportacaoArr;
  }
}
